import { InnerBox } from "@/components/elements/InnerBox";
import { TTalentForm } from "@/features/talent/types/talentForm";
import { divider, black } from "@/theme/colors";
import { rounded } from "@/theme/variables";
import { FCC } from "@/types/common";
import { Stack, Box, Typography } from "@mui/material";

type TTalentInterviewEvaluationProps = {
  defaultValues?: Partial<TTalentForm>;
};

export const TalentInterviewEvaluation: FCC<TTalentInterviewEvaluationProps> = ({ defaultValues }) => {
  return (
    <InnerBox mt={4} p={3} showDivider={false} borderColor={divider.high} bordered={true}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Box flex={1}>
          <Typography variant="head20Bold" color={black[30]}>
            面談評価
          </Typography>
        </Box>
      </Stack>

      {defaultValues?.interviewEvaluation?.length ? (
        <Stack
          mt={3}
          p={2}
          border={`1px solid ${black[99]}`}
          borderRadius={rounded.xs}
          component="pre"
          sx={{
            fontFamily: "inherit",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            overflowWrap: "break-word",
          }}
        >
          <Typography variant="body14" color={black[30]}>
            {defaultValues.interviewEvaluation}
          </Typography>
        </Stack>
      ) : null}
    </InnerBox>
  );
};
